// /src/components/profile/index.js
import React, { Component } from "react";

import "../../components/tabsApps/style/style.css";
import withOutsideClick from "../../hocs/withOutsideClick";
import { connect } from "react-redux";
import "../../components/profile/style/style.css";
import { setIdpInitiatedLogin } from "../../reducers/authReducer";
import { UserIcon } from "../../lib/icons";
import { setUserHomepage } from "../../reducers/appReducer";
import LogoutDialog from "../../components/logoutDialog/logoutDialog";
import SessionTimeoutDialog from "../../components/sessionTimeoutDialog/sessionTimeoutDialog";
import withRouter from "../../hocs/withRouter";

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listOpen: false,
      showLogoutDialog: false,
      showSessionTimeoutDialog: false,
      sessionExpiresAt: 0,
      items: [
        { name: "Make Current Page My Homepage", action: "makeCurrent" },
        { name: "Clear Personal Homepage", action: "clearHomePage" },
        { name: "Manage Subscriptions", action: "manageSubscriptions" },
        { name: "Logout", action: "logout" },
      ],
    };

    this.clickHandler = this.clickHandler.bind(this);
    this.checkForIframeClick = this.checkForIframeClick.bind(this);
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
    this.handleAppLogout = this.handleAppLogout.bind(this);
    this.handleFullLogout = this.handleFullLogout.bind(this);
    this.handleStaySignedIn = this.handleStaySignedIn.bind(this);
    this.handleLogoutNow = this.handleLogoutNow.bind(this);

    window.addEventListener("blur", this.checkForIframeClick, false);
  }

  componentDidMount() {
    // Register logout dialog handler with auth
    if (this.props.auth) {
      this.props.auth.onShowLogoutDialog = () => {
        this.setState({
          showLogoutDialog: true,
          listOpen: false,
        });
      };
      this.props.auth.onIdleWarning = (expiresAt) => {
        this.setState({
          showSessionTimeoutDialog: true,
          sessionExpiresAt: expiresAt,
        });
      };
      this.props.auth.onIdleWarningDismiss = () => {
        this.setState({ showSessionTimeoutDialog: false });
      };
    }
  }

  componentWillUnmount() {
    window.removeEventListener("blur", this.checkForIframeClick, false);

    // Cleanup auth callback
    if (this.props.auth) {
      this.props.auth.onShowLogoutDialog = null;
      this.props.auth.onIdleWarning = null;
      this.props.auth.onIdleWarningDismiss = null;
    }
  }

  checkForIframeClick = (event) => {
    if (document.activeElement.tagName === "IFRAME") {
      this.setState({
        listOpen: false,
      });
    }
  };

  clickHandler(link) {
    switch (link) {
      case "logout":
        this.handleLogoutClick();
        break;
      case "makeCurrent":
        // Preserve query string (e.g. ?appId=) so a homepage set while viewing
        // a report inside a custom app still opens within that custom app.
        let homePage = { link: this.props.location.pathname + this.props.location.search };
        this.props.setUserHomepage(homePage);
        this.toggleList();
        break;
      case "clearHomePage":
        this.props.setUserHomepage(null);
        this.toggleList();
        break;
      case "manageSubscriptions":
        window.open("/reportSubscriptions", "_blank");
        this.toggleList();
        break;
      default:
        this.toggleList();
    }
  }

  handleLogoutClick() {
    // Close the profile dropdown
    this.setState({ listOpen: false });

    // Check if SSO - if so, skip dialog and logout directly
    const sso = localStorage.getItem("sso");
    if (sso === "true") {
      this.logout();
      return;
    }

    // Show logout dialog for regular Azure AD users
    this.setState({ showLogoutDialog: true });
  }

  handleAppLogout = () => {
    this.setState({ showLogoutDialog: false });
    this.props.setIdpInitiatedLogin(false);
    this.props.auth.logoutFromApp();
  };

  handleFullLogout = () => {
    this.setState({ showLogoutDialog: false });
    this.props.setIdpInitiatedLogin(false);
    this.props.auth.logoutFromMicrosoft(true);
  };

  handleStaySignedIn() {
    this.setState({ showSessionTimeoutDialog: false });
    // updateActivity() also clears auth's own idleWarningShown flag, but the
    // dialog's own visibility is owned here since onIdleWarningDismiss isn't
    // guaranteed to fire before the next render.
    this.props.auth.updateActivity();
  }

  handleLogoutNow() {
    this.setState({ showSessionTimeoutDialog: false });
    this.props.setIdpInitiatedLogin(false);
    this.props.auth.logout("idle", { fullLogout: false });
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.setIdpInitiatedLogin(false);
    this.props.auth.logout("user", { fullLogout: false });
  }

  handleClickOutside() {
    this.setState({
      listOpen: false,
    });
  }

  toggleList() {
    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  }

  renderDDItem(item, index) {
    if (this.props.apps !== undefined && this.props.apps !== null && this.props.apps.length > 0) {
      if (item.action === "manageSubscriptions") {
        let containsRptSubscriptions = this.props.apps.filter((item) => {
          return item.type === "reportSubscriptions";
        });
        if (containsRptSubscriptions.length > 0) {
          return (
            <li className="profile-dd-item" key={index} onClick={() => this.clickHandler(item.action)}>
              {item.name}
            </li>
          );
        } else {
          return null;
        }
      }
    }

    if (item.action === "makeCurrent") {
      let curUrl = this.props.location.pathname;
      var chkArray = ["files", "mdm", "report"];

      var allowHomePage = false;
      for (var cItem of chkArray) {
        if (curUrl.includes(cItem)) {
          allowHomePage = true;
          break;
        }
      }

      if (allowHomePage) {
        return (
          <li
            className="profile-dd-item"
            data-testid="profile-menu-make-homepage"
            key={index}
            onClick={() => this.clickHandler(item.action)}>
            {item.name}
          </li>
        );
      } else {
        return (
          <li
            className="profile-dd-item disabled-text"
            data-testid="profile-menu-make-homepage"
            style={{ color: "rgb(215, 217, 220)", cursor: "no-drop" }}
            key={index}>
            {item.name}
          </li>
        );
      }
    } else if (item.action === "clearHomePage") {
      return (
        <li
          className="profile-dd-item"
          data-testid="profile-menu-clear-homepage"
          key={index}
          onClick={() => this.clickHandler(item.action)}>
          {item.name}
        </li>
      );
    } else {
      return (
        <li className="profile-dd-item" key={index} onClick={() => this.clickHandler(item.action)}>
          {item.name}
        </li>
      );
    }
  }

  render() {
    const { listOpen, items, showLogoutDialog, showSessionTimeoutDialog, sessionExpiresAt } = this.state;
    const user = localStorage.getItem("user");

    return (
      <>
        <div className={this.props.className + " flex-container"} data-testid="user-profile">
          {listOpen ? (
            <div
              className="ta-profile-parent profile-parent-selected"
              onClick={() => this.toggleList()}
              data-testid="profile-button">
              <UserIcon color={"white"} height={"20"} className="profile-selected" />
            </div>
          ) : (
            <div className="ta-profile-parent" onClick={() => this.toggleList()} data-testid="profile-button">
              <UserIcon color={"rgba(88, 89, 91, 1)"} height={"20"} />
            </div>
          )}
          {listOpen && (
            <ul className="profile-dd-items" data-testid="profile-dropdown">
              {user !== "" && (
                <div className="profile-user-name" data-testid="profile-username">
                  <li style={{ marginRight: "auto", marginLeft: "auto" }}>{user}</li>
                </div>
              )}
              {items.map((item, index) => this.renderDDItem(item, index))}
            </ul>
          )}
        </div>

        <LogoutDialog
          show={showLogoutDialog}
          onHide={() => this.setState({ showLogoutDialog: false })}
          onAppLogout={this.handleAppLogout}
          onFullLogout={this.handleFullLogout}
        />

        <SessionTimeoutDialog
          show={showSessionTimeoutDialog}
          expiresAt={sessionExpiresAt}
          onStaySignedIn={this.handleStaySignedIn}
          onLogoutNow={this.handleLogoutNow}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  setAllowHomePage: state.app.setAllowHomePage,
  apps: state.app.apps,
});

const mapDispatchToProps = (dispatch) => ({
  setIdpInitiatedLogin(value) {
    dispatch(setIdpInitiatedLogin(value));
  },
  setUserHomepage(obj) {
    dispatch(setUserHomepage(obj));
  },
});

Profile = withOutsideClick(Profile);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile));
